import { PreloaderBubbles } from '@components/PreloaderBubbles';
import { Box } from '@mui/material';
import { buildDataTestId, scrollBarSM } from '@src/utils';
import { DiagnosesGroupItem } from '../../DiagnosesInput.components';
import { diagnosesGroupsApiSlice } from '@src/api';
import { defaultFilterValues } from '../../consts';
import { FC } from 'react';

type DiagnosesPaperGroupsProps = {
  search: string;
  allDiagnosesGroups;
  setSelectedDiagnosesGroupLocal;
  dataTestId?: string;
};

export const DiagnosesPaperGroups: FC<DiagnosesPaperGroupsProps> = ({
  search,
  allDiagnosesGroups,
  setSelectedDiagnosesGroupLocal,
  dataTestId,
}) => {
  const { data: diagnosesGroups, isLoading } = diagnosesGroupsApiSlice.useGetDiagnosesGroupsQuery({
    ...defaultFilterValues,
    search: search || '',
  });
  return (
    <Box position="relative" overflow="auto" height="calc(100% - 54px)" sx={scrollBarSM}>
      {isLoading && <PreloaderBubbles overlay="light" size={16} />}
      {diagnosesGroups && diagnosesGroups.length > 0
        ? diagnosesGroups.map((group, index) => (
            <DiagnosesGroupItem
              key={group.id}
              id={group.id}
              name={group.name}
              withDelete={false}
              withCheckbox
              selectedDiagnoses={allDiagnosesGroups}
              setSelectedDiagnosesGroupLocal={setSelectedDiagnosesGroupLocal}
              dataTestId={buildDataTestId(dataTestId, `diagnoses-group-${index}`)}
            />
          ))
        : null}
    </Box>
  );
};
